import NumberRange from "./src/index.vue";
import type { App } from "vue";
NumberRange.install = function (Vue: App): void {
  console.info("NumberRange----install----");
  Vue.component(NumberRange.name, NumberRange);
};

export default NumberRange;
